import styled, { css } from 'styled-components';
import BaseTable from 'react-base-table';
import { lighten } from 'polished';

export const ScheduleListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin-top: 5px;
  padding: 15px;
  flex: 1;
  position: relative;
`;

export const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #e9edf0;
  padding-bottom: 10px;
`;

export const TableWrapper = styled.div`
  min-height: 500px;
  margin: 20px 0;
  height: 100%;
  // add to style of calendar plugin element
  .fc-event-time {
    color: #000;
  }

  .fc-event-title {
    text-overflow: ellipsis;
    color: #000;
  }

  .not-waiting-schedule {
    cursor: auto;
    color: #aaa;
  }
`;

export const Title = styled.div`
  font-weight: 400;
  font-size: 1.25em;
  margin: 0 10px;
`;

export const FlexFill = styled.div`
  display: flex;
  flex: 1;
`;

export const StyledBaseTable = styled(BaseTable)`
  font-size: 1.1em;
  border: none;
  box-shadow: none;

  .BaseTable__table-main {
    outline: none;
  }

  .BaseTable__row {
    border-bottom: none;

    &:hover {
      background-color: initial;
    }
  }

  .BaseTable__header-row {
    border-bottom: none;
    outline: none;
    font-weight: 300;
  }

  .BaseTable__header-cell-text {
    font-weight: 600;
  }
`;

const BaseIconStyles = css`
  display: inline-block;
  cursor: pointer;
  font-size: 1.25em;
  margin: 0 10px;
  line-height: 0.5;
`;

export const IconWrap = styled('div')`
  ${BaseIconStyles}
  &.selected {
    svg {
      path,
      circle {
        fill: #1093f5;
        stroke: #1093f5;
      }

      rect {
        stroke: #1093f5;
      }
    }
  }
`;

export const StatusIconWrap = styled('div')<any>`
  ${BaseIconStyles}
  svg {
    fill: ${(props) => lighten(0.15, props.backgroundColor)};
  }
`;
